<template>
    <div class="all-applications">
        <div class="all-applications__content">
            <Card
                v-for="(card, cardIndex) in cards"
                :key="cardIndex"
                :card="card"
                :card-index="cardIndex"
                :is-loaded="isLoaded"
                :search-fields="['title', 'bundle_id']"
                @addApp="addApp"
                @editApp="editApp"
            />
        </div>
    </div>
</template>

<script>
    import Card from './AllApplications/Card';
    
    export default {
        name: 'AllApplications',
        components: {Card},
        props: {
            cards: {
                type: Array,
                required: false,
                default: () => ([]),
            },
            isLoaded: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                currentCardIndex: 0,
            };
        },
        methods: {
            addApp(cardIndex) {
                this.$emit('addApp', cardIndex);
            },
            editApp(app, appIndex, cardIndex) {
                this.$emit('editApp', app, appIndex, cardIndex);
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .all-applications {
        &__title {
            font-size: 16px;
            line-height: 20px;
            font-weight: 700;
            text-align: left;
            margin-bottom: 26px;
        }
        
        &__content {
            display: flex;
            flex-wrap: wrap;
        }
    }
</style>